module.exports = __webpack_public_path__ + "img/logo_doudian.4b48b2db.svg";